export default __webpack_public_path__ + "static/media/reviewsImg.65665409.png";